import React, { useState, useEffect } from "react";
import { message } from "antd";
import { trackPromise } from "react-promise-tracker";
import "./styles.scss";
import {
  getLoginImage,
  postLoginImage,
  uploadLoginImage,
} from "../../../../services/http/loginImageService.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";
import lang from "../../../../assets/idioma/idiomas.js";

export default function LoginImageForm({ setTipoFormulario }) {
  const history = useHistory();

  const [loginImage, setLoginImage] = useState({
    urlArquivo: "",
  });
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [urlImagemUploaded, setUrlImagemUploaded] = useState(null);
  const [isImporting, setIsImporting] = useState(false);

  useEffect(() => {
    fnGetLoginImage();
  }, []);

  const fnGetLoginImage = () => {
    trackPromise(
      getLoginImage()
        .then((res) => {
          if (res && res.data && res.data.urlArquivo) {
            setLoginImage({
              urlArquivo: res.data.urlArquivo,
            });
          } else {
            setLoginImage({ urlArquivo: "" });
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar imagem:", error);
          setLoginImage({ urlArquivo: "" });
        })
    );
  };

  const fnPostLoginImage = () => {
    if (!urlImagemUploaded && !loginImage.urlArquivo) {
      message.warning("Por favor, selecione e faça upload de uma imagem antes de salvar.");
      return;
    }

    const urlParaSalvar = urlImagemUploaded || loginImage.urlArquivo;

    if (urlParaSalvar) {
      trackPromise(
        postLoginImage(urlParaSalvar)
          .then((res) => {
            if (!res.fail && res.data) {
              message.success("Imagem da tela de login atualizada com sucesso!");
              setArquivoSelecionado(null);
              setUrlImagemUploaded(null);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              message.error(res.fail?.message || "Erro ao salvar a imagem.");
            }
          })
          .catch((error) => {
            console.error(error);
            message.error("Erro ao atualizar a imagem da tela de login.");
          })
      );
    } else {
      message.warning("Por favor, selecione uma nova imagem para atualizar.");
    }
  };

  const fnSelecionarImagem = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Mostra mensagem de importando
    setIsImporting(true);
    const hideLoading = message.loading({
      content: "Importando imagem...",
      duration: 0,
      key: "importing-image",
    });

    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const validFormats = ["image/png", "image/jpeg", "image/jpg"];
        if (!validFormats.includes(file.type)) {
          hideLoading();
          setIsImporting(false);
          message.warning("Formato inválido. Apenas PNG, JPG e JPEG são aceitos.");
          return;
        }

        setArquivoSelecionado(file);

        trackPromise(
          uploadLoginImage(file, "login-image")
            .then((res) => {
              hideLoading();
              setIsImporting(false);
              if (!res.fail && res.data) {
                const urlUploaded = res.data;
                setUrlImagemUploaded(urlUploaded);
                setLoginImage((prev) => ({ ...prev, urlArquivo: urlUploaded }));
                message.success("Imagem carregada com sucesso! Clique em Salvar para aplicar.");
              } else {
                message.error(res.fail?.message || "Erro ao fazer upload da imagem.");
              }
            })
            .catch((error) => {
              hideLoading();
              setIsImporting(false);
              console.error(error);
              message.error("Erro ao fazer upload da imagem.");
            })
        );
      };
      img.onerror = () => {
        hideLoading();
        setIsImporting(false);
        message.error("Erro ao carregar a imagem selecionada.");
      };
      img.src = event.target.result;
    };

    reader.onerror = () => {
      hideLoading();
      setIsImporting(false);
      message.error("Erro ao ler o arquivo selecionado.");
    };

    reader.readAsDataURL(file);
  };

  return (
    <div >
      <div className="row">
        <div
          className="col-md-12"
          style={{ borderBottom: "1px solid #898989" }}
        >
          <span className="titulo-perm">
            {lang.Imagem_Tela_de_Login || "Imagem Tela de Login"}
          </span>
        </div>
      </div>

      <br />

      {/* IMPORTAR IMAGEM */}
      <div className="row">
        <div className="col-md-4">
          <input
            type="file"
            accept="image/*"
            id="inputImagemLogin"
            onChange={(e) => fnSelecionarImagem(e)}
            style={{ display: "none" }}
          />
          <button
            onClick={() => document.querySelector("#inputImagemLogin").click()}
            className="btn-bannersPrimary"
          >
            {lang.Importar_arquivo || "Importar arquivo"}
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <span className="textoBanner">
            {lang.Somente_imagens_nos_formatos_sao_aceitas ||
              "Serão aceitas somente imagens nos formatos:"}
          </span>
          <br />
          <span className="textoBanner">
            {lang.Png_Jgp_E_Jpeg || "PNG, JPG E JPEG."}
          </span>
          <br />
          <span className="textoBanner">
            {lang.Dimensoes_recomendadas_para_imagem_login ||
              "As dimensões recomendadas são flexíveis, mas recomenda-se imagens de alta qualidade."}
          </span>
          <br />
          <span className="textoBanner" style={{ fontWeight: "bold" }}>
            Sugestão de tamanho: 1920 x 930
          </span>
          <br />
        </div>
      </div>

      {/* IMAGEM */}
      <div className="row">
        <div className="col-md-12 p-0 mt-5 mb-5">
          {loginImage.urlArquivo ? (
            <img
              width={"100%"}
              src={loginImage.urlArquivo}
              alt="Imagem da tela de login"
              style={{
                height: "400px",
                maxWidth: "100%",
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
                paddingLeft: "20px",
              }}
              onError={() => fnGetLoginImage()}
            />
          ) : (
            <div
              style={{
                padding: "40px",
                textAlign: "center",
                border: "2px dashed #ccc",
                borderRadius: "8px",
                color: "#999",
              }}
            >
              <p>Nenhuma imagem configurada</p>
              <p style={{ fontSize: "12px" }}>
                Faça upload de uma imagem para visualizar o preview
              </p>
            </div>
          )}
        </div>
      </div>

      {/* BOTOES */}
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 ">
          <button
            onClick={() => window.location.reload()}
            type="submit"
            className="btn-bannersSecundary"
            style={{ marginTop: "5px" }}
          >
            {lang.Cancelar || "Cancelar"}
          </button>
        </div>
        <div className="col-md-4 ">
          <button
            onClick={() => fnPostLoginImage()}
            type="submit"
            className="btn-bannersPrimary"
            style={{ marginTop: "5px" }}
          >
            {lang.Salvar || "Salvar"}
          </button>
        </div>
      </div>

      <br />
    </div>
  );
}
